export default __webpack_public_path__ + "static/media/6.51e3ece3.jpeg";